/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PositionCto } from '../../models/position-cto';

export interface GetJobAsync$Plain$Params {
  positionGuid: string;
}

export function getJobAsync$Plain(http: HttpClient, rootUrl: string, params: GetJobAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<PositionCto>> {
  const rb = new RequestBuilder(rootUrl, getJobAsync$Plain.PATH, 'get');
  if (params) {
    rb.path('positionGuid', params.positionGuid, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PositionCto>;
    })
  );
}

getJobAsync$Plain.PATH = '/job/{positionGuid}';
